import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastAdvertencia, toastError, toastExito } from "@/lib/toast";
import { extractApiMessage } from "@/shared/api/extract-message";
import {
  crearSolicitudCatalogo,
  obtenerEstadoSolicitudCatalogo,
  type CrearSolicitudCatalogoInput,
} from "../services/solicitudes-catalogo.api";

/**
 * Estado de la solicitud de alta para (tipo, clave) · decide si la UI muestra
 * el botón de "Solicitar alta" o el aviso de que ya hay una pendiente.
 */
export function useEstadoSolicitudCatalogo(tipo: string, clave: string, enabled = true) {
  return useQuery({
    queryKey: qk.solicitudCatalogoEstado(tipo, clave),
    queryFn: () => obtenerEstadoSolicitudCatalogo(tipo, clave),
    enabled,
    staleTime: 30_000,
  });
}

export function useCrearSolicitudCatalogo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CrearSolicitudCatalogoInput) => crearSolicitudCatalogo(input),
    onSuccess: (resultado, input) => {
      void qc.invalidateQueries({
        queryKey: qk.solicitudCatalogoEstado(input.tipo, input.clave.toUpperCase()),
      });
      if (resultado.yaExistia) {
        toastAdvertencia({
          title: "Ya estaba solicitado",
          message: "Ya existe una solicitud pendiente para este elemento · el administrador la tiene en su bandeja.",
        });
      } else {
        toastExito({
          title: "Solicitud enviada",
          message: "El administrador recibió tu solicitud en su bandeja de Solicitudes de catálogos.",
        });
      }
    },
    onError: (error: unknown) => {
      toastError({ title: "No se pudo enviar la solicitud", message: extractApiMessage(error, "Intenta de nuevo.") });
    },
  });
}
